import React from "react";
import { useSiteSettings } from "../lib/hooks";

const HERO = "https://images.pexels.com/photos/18108314/pexels-photo-18108314.jpeg";

const About = () => {
  const s = useSiteSettings();
  return (
    <div data-testid="page-about">
      <section className="relative min-h-[60vh] bg-[#111111] flex items-end pb-16">
        <img src={HERO} alt="Autobahn showroom" className="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#111111] to-transparent" />
        <div className="container-wide relative z-10 text-white">
          <div className="overline text-[#7A1519] mb-4">About Autobahn Cars</div>
          <h1 className="font-display text-5xl md:text-7xl tracking-tighter font-light leading-[0.95] max-w-3xl">
            Considered. Curated. Delivered.
          </h1>
          <p className="mt-6 text-white/80 max-w-xl">Adding Luxury to Life — one carefully selected vehicle at a time.</p>
        </div>
      </section>

      <section className="container-wide py-24 space-y-24">
        {(s?.about_sections || []).map((sec, i) => (
          <div key={i} className="grid grid-cols-1 lg:grid-cols-12 gap-10 border-b hairline pb-24 last:border-0" data-testid={`about-section-${i}`}>
            <div className="lg:col-span-3">
              <div className="overline text-[#7A1519]">Chapter {String(i + 1).padStart(2, "0")}</div>
              <h2 className="mt-3 font-display text-2xl md:text-3xl tracking-tight font-semibold text-[#111111]">{sec.heading}</h2>
            </div>
            <div className="lg:col-span-9">
              <p className="text-[#242424] text-lg leading-relaxed whitespace-pre-line">{sec.body}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default About;
